import { render, staticRenderFns } from "./ExternalAuth.vue?vue&type=template&id=48de4caf&scoped=true&"
import script from "./ExternalAuth.vue?vue&type=script&lang=js&"
export * from "./ExternalAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de4caf",
  null
  
)

export default component.exports